import type { ReviewMark } from '../../ui/kit/components/reviewModel';
export type { ReviewMark } from '../../ui/kit/components/reviewModel';
export { marksAt, formatTimecode } from '../../ui/kit/components/reviewModel';
export interface GuestItem {
  id: string;
  label: string;
  description: string;
  status: string;
  mime?: string;
  mediaName?: string;
  mediaUrl?: string | null;
  downloadUrl?: string | null;
  supersededByItemId?: string | null;
  entityType?: string;
  renderMode?: string;
  reviewPayload?: Record<string, unknown> | null;
  outdated?: boolean;
  pinnedVersionId?: string | null;
}
export interface GuestComment {
  id: string;
  item_id: string;
  guest_name: string;
  text: string;
  created_at: string;
  edited_at?: string;
  parent_id?: string;
  status: string;
  annotations: ReviewMark[];
  timecode?: number | null;
  voiceUrl?: string | null;
}
export interface GuestReview {
  presentation: {
    id: string;
    title: string;
    projectName: string;
    description?: string;
    status: string;
    identityRequired: boolean;
    watermarkPolicy: string;
    expiresAt: string;
  };
  brand?: { name: string; accent: string };
  viewer?: { name: string; email?: string } | null;
  watermarkText?: string | null;
  items: GuestItem[];
  comments: GuestComment[];
  decisions: { id: string; item_id: string; guest_name: string; decision: string; note?: string }[];
}
export function reviewToken(search: string, hash: string) {
  const fragment = hash.replace(/^#/, '');
  let raw = '';
  if (!fragment.includes('=')) {
    try {
      raw = decodeURIComponent(fragment);
    } catch {
      raw = fragment;
    }
  }
  return (
    new URLSearchParams(fragment).get('review') ||
    raw ||
    new URLSearchParams(search).get('review') ||
    ''
  );
}
export const currentItems = (items: GuestItem[]) => items.filter((item) => !item.supersededByItemId);
export const previousItem = (items: GuestItem[], item: GuestItem) =>
  items.find((row) => row.supersededByItemId === item.id) || null;
export const writableItem = (data: GuestReview, item: GuestItem) =>
  data.presentation.status !== 'completed' && !item.supersededByItemId && !item.outdated;
export const reviewPath = (token: string) => `/public-review/${encodeURIComponent(token)}`;
export function passcodeHeaders(passcode?: string): Record<string, string> {
  return passcode ? { 'X-Review-Passcode': passcode } : {};
}
export function storedPasscode(token: string) {
  try {
    return sessionStorage.getItem(`cinema_review_passcode:${token}`) || '';
  } catch {
    return '';
  }
}
export function storePasscode(token: string, value: string) {
  try {
    if (value) sessionStorage.setItem(`cinema_review_passcode:${token}`, value);
    else sessionStorage.removeItem(`cinema_review_passcode:${token}`);
  } catch {
    /* sessionStorage can be unavailable in private review rooms */
  }
}
